<scitis-breadcrumb [breadcrumbRoutes]="breadcrumbRoutes"></scitis-breadcrumb>
<scitis-app-global-page-header>
  <div header-title>
    <scitis-page-header-logo-and-name
        [machineCategory]="pageGlobalParameters.machineCategory"
        [pageName]="pageGlobalParameters.pageName"
        [machineId]="pageGlobalParameters.machineId"
        [machineMenuItem]="pageGlobalParameters.associatedMenuItem.menuItemParent"
        [pageType]="pageGlobalParameters.pageType">
    </scitis-page-header-logo-and-name>
  </div>

  <ng-template #filterElement>
    <scitis-form-page-actions
        (formPageConfigurationChange)="onSaveFormConfiguration($event)"
        [formPageConfiguration]="formPageConfiguration"
        [isTechAdminOrHigher]="isTechAdminOrHigher"
        [machineId]="pageGlobalParameters.machineId">
    </scitis-form-page-actions>
  </ng-template>
</scitis-app-global-page-header>

<div class="page-content">
  <scitis-form-page
      [formPageConfiguration]="formPageConfiguration"
      [machineId]="pageGlobalParameters.machineId">
  </scitis-form-page>
</div>
